export class EndCard {
  file: null;
  packshot: any;
  volume: number;
  transitionStyleId: number;

  constructor() {
    this.file = null;
    this.packshot = null;
    this.volume = 1;
    this.transitionStyleId = 4;
  }

  static copyFromParsed(parsedEndCard): EndCard {
    const newEndCard = new EndCard();
    const parsedEndCardObj = JSON.parse(JSON.stringify(parsedEndCard));

    newEndCard.file = parsedEndCardObj.file;
    newEndCard.packshot = parsedEndCardObj.packshot;
    newEndCard.volume = parsedEndCardObj.volume;
    newEndCard.transitionStyleId = parsedEndCardObj.transitionStyleId;

    return newEndCard;
  }

  getType() {
    return this.packshot.type;
  }

  getDuration(currentSizeName) {
    if (this.packshot) {
      if (this.getType() === "video") {
        return this.packshot.list[currentSizeName].duration;
      }
      if (this.getType() === "template-default") {
        return (
          (this.getAnimationPropAtPath(
            this.packshot.model.duration.main.op.path
          ) -
            this.getAnimationPropAtPath(
              this.packshot.model.duration.main.ip.path
            )) /
          this.getAnimationPropAtPath(this.packshot.model.fps.path)
        );
      }
    } else return 0;
  }

  getFPS() {
    if (this.packshot && this.getType() === "template-default") {
      return this.getAnimationPropAtPath(this.packshot.model.fps.path);
    } else return null;
  }

  getPathAndLastKeyAnimationProp(pathString) {
    const keys = pathString.split(/\.|\[|\]/);
    const lastIndex =
      keys[keys.length - 1] !== "" ? keys.length - 1 : keys.length - 2;
    const lastKey = keys[lastIndex];

    let path = this.packshot.json;
    keys.forEach((key, index) => {
      if (key !== "" && index !== lastIndex) {
        path = path[key];
      }
    });

    return { path: path, key: lastKey };
  }

  getAnimationPropAtPath(pathString) {
    return this.getPathAndLastKeyAnimationProp(pathString).path[
      this.getPathAndLastKeyAnimationProp(pathString).key
    ];
  }

  getAnimationLayerColor(pathString) {
    const colorArrFraction = this.getAnimationPropAtPath(pathString);
    const [r, g, b] = colorArrFraction.map((item) => Math.round(item * 255));
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  getAnimationLayerColorGradient(pathString, startColor) {
    const gradient = this.getAnimationPropAtPath(pathString);
    const colorArrFraction = [
      gradient[startColor + 1],
      gradient[startColor + 2],
      gradient[startColor + 3],
    ];
    const [r, g, b] = colorArrFraction.map((item) => Math.round(item * 255));
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  updatePropInAnimationPath(value, pathString) {
    const pathAndLastKey = this.getPathAndLastKeyAnimationProp(pathString);
    pathAndLastKey.path[pathAndLastKey.key] = value;
  }

  updateInscribeTextInWidthAnimation(val, layer) {
    this.updatePropInAnimationPath(val, layer.text.path);

    const findTextSize = (size) => {
      if (
        size *
        layer.text.coef *
        this.getAnimationPropAtPath(layer.text.path).length >
        layer.text.maxWidth
      ) {
        return findTextSize(size - 1);
      } else {
        return size;
      }
    };

    const newTextSize = findTextSize(layer.size.max);

    this.updatePropInAnimationPath(newTextSize, layer.size.path);

    this.updatePropInAnimationPath(
      (this.getAnimationPropAtPath(layer.size.path) / layer.size.defaultValue) *
      layer.bottomPadding.defaultValue,
      layer.bottomPadding.path
    );
  }

  updateSizeTextCenterAnimation(val, layer) {
    this.updatePropInAnimationPath(val, layer.size.path);

    this.updatePropInAnimationPath(
      (this.getAnimationPropAtPath(layer.size.path) / layer.size.defaultValue) *
      layer.bottomPadding.defaultValue,
      layer.bottomPadding.path
    );
  }

  updateSizeUpTextCenterAnimation(layer, step) {
    this.updatePropInAnimationPath(
      this.getAnimationPropAtPath(layer.size.path) + step,
      layer.size.path
    );

    this.updatePropInAnimationPath(
      ((this.getAnimationPropAtPath(layer.size.path) + step) /
        layer.size.defaultValue) *
      layer.bottomPadding.defaultValue,
      layer.bottomPadding.path
    );
  }

  updateSizeDownTextCenterAnimation(layer, step) {
    this.updatePropInAnimationPath(
      this.getAnimationPropAtPath(layer.size.path) - step,
      layer.size.path
    );

    this.updatePropInAnimationPath(
      ((this.getAnimationPropAtPath(layer.size.path) - step) /
        layer.size.defaultValue) *
      layer.bottomPadding.defaultValue,
      layer.bottomPadding.path
    );
  }

  updateBorderRadiusAnimation(val, layer) {
    this.updatePropInAnimationPath(
      (val / 100) * layer.radius.max,
      layer.radius.path
    );
  }

  updateLineWidthAnimation(val, layer) {
    this.updatePropInAnimationPath(val, layer.width.path);
  }

  updateBlurAnimation(val, layer) {
    this.updatePropInAnimationPath(val, layer.blur.path);
  }

  updateColorAnimation(val, layer) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(val);
    const colorRGB = result
      ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
      : [0, 0, 0];
    const colorArrFraction = colorRGB.map((item) => item / 255);

    const pathAndLastKey = this.getPathAndLastKeyAnimationProp(
      layer.color.path
    );
    const currentColor = pathAndLastKey.path[pathAndLastKey.key];
    [currentColor[0], currentColor[1], currentColor[2]] = colorArrFraction;

    // Жёсткое обновление оверлея для реактивного обновления цвета

    this.packshot = {
      ...this.packshot,
      json: { ...this.packshot.json },
    };
  }

  updateColorGradientAnimation(val, layer) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(val);
    const colorRGB = result
      ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
      : [0, 0, 0];
    const colorArrFraction = colorRGB.map((item) => item / 255);

    const pathAndLastKey = this.getPathAndLastKeyAnimationProp(
      layer.color.path
    );
    const currentColor = pathAndLastKey.path[pathAndLastKey.key];
    [
      currentColor[layer.color.startColor + 1],
      currentColor[layer.color.startColor + 2],
      currentColor[layer.color.startColor + 3],
    ] = colorArrFraction;

    layer.color.connectedStartColors.forEach((connectedstartColor) => {
      const startColor = (connectedstartColor + layer.color.startColor) / 2;
      [
        currentColor[startColor + 1],
        currentColor[startColor + 2],
        currentColor[startColor + 3],
      ] = [
          (currentColor[connectedstartColor + 1] +
            currentColor[layer.color.startColor + 1]) /
          2,
          (currentColor[connectedstartColor + 2] +
            currentColor[layer.color.startColor + 2]) /
          2,
          (currentColor[connectedstartColor + 3] +
            currentColor[layer.color.startColor + 3]) /
          2,
        ];
    });

    // Жёсткое обновление оверлея для реактивного обновления цвета

    this.packshot = {
      ...this.packshot,
      json: { ...this.packshot.json },
    };
  }

  updateLogoImageAnimation(base64Image, layer) {
    this.updatePropInAnimationPath(base64Image, layer.image.path);
    //this.updatePropInAnimationPath(w, layer.w.path);
    //this.updatePropInAnimationPath(h, layer.h.path);
    // Жёсткое обновление оверлея для реактивного обновления цвета

    this.packshot = {
      ...this.packshot,
      json: { ...this.packshot.json },
    };
  }

  updateOpacityAnimation(val, layer) {
    this.updatePropInAnimationPath(parseInt(val), layer.opacity.path);

    // Жёсткое обновление оверлея для реактивного обновления глазика

    this.packshot = {
      ...this.packshot,
      json: { ...this.packshot.json },
    };
  }

  switchBlock(val, block) {
    this.updatePropInAnimationPath(parseInt(val), block.switch.path);
  }

  switchGroup(val, group) {
    this.updatePropInAnimationPath(parseInt(val), group.switch.path);

    this.packshot = {
      ...this.packshot,
      json: { ...this.packshot.json },
    };
  }

// so much duplicate code, need refactor
  applyModifiedValuesForNewSize() {
    if (!this?.packshot?.modifiedValues?.blocks) {
      return null;
    }
    this.packshot.modifiedValues.blocks.forEach((b) => {
      const currentBlock = this.packshot.model.blocks.find(
        (block) => b.id === block.id
      );
      
      if (currentBlock) {
        if (b.hasOwnProperty('switch')) {
          this.switchBlock(
            b.switch.value,
            currentBlock
          );
        }

    if (b.hasOwnProperty('groups')) {
      b.groups.forEach((g) => {
        const currentGroup = currentBlock.groups.find(
          (group) => g.id === group.id
        );

        if (currentGroup) {
          if (g.hasOwnProperty('switch') && currentGroup.switch.type === 'recalculable') {
            this.switchGroup(
              g.switch.value,
              currentGroup
            );
          }
        }

        if (g.hasOwnProperty('layers')) {
          g.layers.forEach((l) => {


            const currentLayer = currentGroup.layers.find(
              (layer) => l.id === layer.id
            );
            if (currentLayer) {
              switch (currentLayer.type) {
                case "inscribe-text-in-width":
                  if (
                    currentLayer.hasOwnProperty("text") &&
                    l.hasOwnProperty("text")
                  ) {
                    this.updateInscribeTextInWidthAnimation(
                      l.text.value,
                      currentLayer
                    );
                  }
                  if (
                    currentLayer.hasOwnProperty("size") &&
                    l.hasOwnProperty("size")
                  ) {
                    this.updateSizeTextCenterAnimation(
                      l.size.value,
                      currentLayer
                    );
                  }
                  break;
                case "color-opacity":
                  if (
                    currentLayer.hasOwnProperty("color") &&
                    l.hasOwnProperty("color")
                  ) {
                    this.updateColorAnimation(l.color.value, currentLayer);
                  }
                  if (
                    currentLayer.hasOwnProperty("opacity") &&
                    l.hasOwnProperty("opacity")
                  ) {
                    this.updateOpacityAnimation(l.opacity.value, currentLayer);
                  }
                  if (
                    currentLayer.hasOwnProperty("isVisible") &&
                    l.hasOwnProperty("isVisible")
                  ) {
                    currentLayer.isVisible = l.isVisible.value;
                    currentLayer.tempValue = l.tempValue.value;
                    this.updateOpacityAnimation(l.opacity.value, currentLayer);
                  }
                  break;
                case "color-gradient":
                  if (
                    currentLayer.hasOwnProperty("color") &&
                    l.hasOwnProperty("color")
                  ) {
                    this.updateColorGradientAnimation(
                      l.color.value,
                      currentLayer
                    );
                  }
                  break;
                case "border-radius":
                  if (
                    currentLayer.hasOwnProperty("radius") &&
                    l.hasOwnProperty("radius")
                  ) {
                    this.updateBorderRadiusAnimation(
                      l.radius.value,
                      currentLayer
                    );
                  }
                  break;
                case "line-width":
                  if (
                    currentLayer.hasOwnProperty("width") &&
                    l.hasOwnProperty("width")
                  ) {
                    this.updateLineWidthAnimation(l.width.value, currentLayer);
                  }
                  break;
                case "blur":
                  if (
                    currentLayer.hasOwnProperty("blur") &&
                    l.hasOwnProperty("blur")
                  ) {
                    this.updateBlurAnimation(l.blur.value, currentLayer);
                  }
                  break;
                case "image":
                  if (
                    currentLayer.hasOwnProperty("image") &&
                    l.hasOwnProperty("image")
                  ) {
                    this.updateLogoImageAnimation(l.image.value, currentLayer);
                  }
                  if (
                    currentLayer.hasOwnProperty("opacity") &&
                    l.hasOwnProperty("opacity")
                  ) {
                    this.updateOpacityAnimation(l.opacity.value, currentLayer);
                  }
                  break;
              }

            }
          })
        };

      })
    }

        
        if (b.hasOwnProperty('layers')) {
          b.layers.forEach((l) => {


            const currentLayer = currentBlock.layers.find(
              (layer) => l.id === layer.id
            );
            if (currentLayer) {
              switch (currentLayer.type) {
                case "inscribe-text-in-width":
                  if (
                    currentLayer.hasOwnProperty("text") &&
                    l.hasOwnProperty("text")
                  ) {
                    this.updateInscribeTextInWidthAnimation(
                      l.text.value,
                      currentLayer
                    );
                  }
                  if (
                    currentLayer.hasOwnProperty("size") &&
                    l.hasOwnProperty("size")
                  ) {
                    this.updateSizeTextCenterAnimation(
                      l.size.value,
                      currentLayer
                    );
                  }
                  break;
                case "color-opacity":
                  if (
                    currentLayer.hasOwnProperty("color") &&
                    l.hasOwnProperty("color")
                  ) {
                    this.updateColorAnimation(l.color.value, currentLayer);
                  }
                  if (
                    currentLayer.hasOwnProperty("opacity") &&
                    l.hasOwnProperty("opacity")
                  ) {
                    this.updateOpacityAnimation(l.opacity.value, currentLayer);
                  }
                  if (
                    currentLayer.hasOwnProperty("isVisible") &&
                    l.hasOwnProperty("isVisible")
                  ) {
                    currentLayer.isVisible = l.isVisible.value;
                    currentLayer.tempValue = l.tempValue.value;
                    this.updateOpacityAnimation(l.opacity.value, currentLayer);
                  }
                  break;
                case "color-gradient":
                  if (
                    currentLayer.hasOwnProperty("color") &&
                    l.hasOwnProperty("color")
                  ) {
                    this.updateColorGradientAnimation(
                      l.color.value,
                      currentLayer
                    );
                  }
                  break;
                case "border-radius":
                  if (
                    currentLayer.hasOwnProperty("radius") &&
                    l.hasOwnProperty("radius")
                  ) {
                    this.updateBorderRadiusAnimation(
                      l.radius.value,
                      currentLayer
                    );
                  }
                  break;
                case "line-width":
                  if (
                    currentLayer.hasOwnProperty("width") &&
                    l.hasOwnProperty("width")
                  ) {
                    this.updateLineWidthAnimation(l.width.value, currentLayer);
                  }
                  break;
                case "blur":
                  if (
                    currentLayer.hasOwnProperty("blur") &&
                    l.hasOwnProperty("blur")
                  ) {
                    this.updateBlurAnimation(l.blur.value, currentLayer);
                  }
                  break;
                case "image":
                  if (
                    currentLayer.hasOwnProperty("image") &&
                    l.hasOwnProperty("image")
                  ) {
                    this.updateLogoImageAnimation(l.image.value, currentLayer);
                  }
                  if (
                    currentLayer.hasOwnProperty("opacity") &&
                    l.hasOwnProperty("opacity")
                  ) {
                    this.updateOpacityAnimation(l.opacity.value, currentLayer);
                  }
                  break;
              }

            }
          })
        };
      };
    })
  }
// so much duplicate code, need refactor
  saveModifiedValues(value, key, layer, group, block) {
    if (!this?.packshot?.modifiedValues?.blocks) {
      this.packshot.modifiedValues = {};
      this.packshot.modifiedValues.blocks = [];
    }
    let modifiedBlock = this.packshot.modifiedValues.blocks.find(
      (b) => b.id === block.id
    );

    if (!modifiedBlock) {
      this.packshot.modifiedValues.blocks = [
        ...this.packshot.modifiedValues.blocks,
        { id: block.id },
      ];

      modifiedBlock = this.packshot.modifiedValues.blocks.find(
        (b) => b.id === block.id
      );
    }

    if (layer === null && group === null) {
      modifiedBlock[key] = {};
      modifiedBlock[key].value = value;
      return null;
    }

    if (group === null) {
      if (!modifiedBlock?.layers) {
        modifiedBlock.layers = [];
      }

      let modifiedLayer = modifiedBlock.layers.find((l) => l.id === layer.id);

      if (!modifiedLayer) {
        modifiedBlock.layers = [...modifiedBlock.layers, { id: layer.id }];
        modifiedLayer = modifiedBlock.layers.find((l) => l.id === layer.id);
      }

      modifiedLayer[key] = {};
      modifiedLayer.type = layer.type;
      modifiedLayer[key].value = value;
      return null;
    }

    if (layer === null) {
      if (!modifiedBlock?.groups) {
      modifiedBlock.groups = [];
      }

      let modifiedGroup = modifiedBlock.groups.find(g => g.id === group.id);


      if (!modifiedGroup) {
        modifiedBlock.groups = [...modifiedBlock.groups, { id: group.id }];
        modifiedGroup = modifiedBlock.groups.find((g) => g.id === group.id);
      }

      modifiedGroup[key] = {};
      modifiedGroup.type = group.type;
      modifiedGroup[key].value = value;
      return null;

    } else {
      if (!modifiedBlock?.groups) {
        modifiedBlock.groups = [];
        }
  
        let modifiedGroup = modifiedBlock.groups.find(g => g.id === group.id);
  
  
        if (!modifiedGroup) {
          modifiedBlock.groups = [...modifiedBlock.groups, { id: group.id }];
          modifiedGroup = modifiedBlock.groups.find((g) => g.id === group.id);
        }

        if (!modifiedGroup?.layers) {
          modifiedGroup.layers = [];
        }
    
        let modifiedLayer = modifiedGroup.layers.find((l) => l.id === layer.id);
    
        if (!modifiedLayer) {
          modifiedGroup.layers = [...modifiedGroup.layers, { id: layer.id }];
          modifiedLayer = modifiedGroup.layers.find((l) => l.id === layer.id);
        }
    
        modifiedLayer[key] = {};
        modifiedLayer.type = layer.type;
        modifiedLayer[key].value = value;
    }
  }
}
